import React from 'react';
import { chipTime } from '../util/mcpbTime';
import WhenFields, { useWhenState, FindEventsChips } from './WhenFields';

/**
 * DtModal — a modal shell around the shared WHEN block (WhenFields + FindEventsChips). Collects
 * Date + Time + Show-window + "Find events with" and, on Go, hands the parent the anchor timestamp +
 * window + filters. The parent (runMcpbSearch) calculates [start, start+window], applies the 10-min
 * lookback, commits the search, and fetches.
 *
 * Phase 1g note: the mobile-portrait ENTRY flow now uses the inline `EntrySearch` (which embeds the
 * same WhenFields), so the View no longer opens this modal on entry. DtModal is retained as the modal
 * variant of the time controls for the Phase-3a desktop "Custom range" surface (build-tracker 3a) —
 * the shared WhenFields keeps it byte-for-byte consistent with the inline entry.
 *
 * Mock: 02-unified-bar.mobile-portrait.html (.dtp-* block). This component owns only the WORKING
 * selection (via useWhenState, seeded once on open from the committed state — Cancel/close discards it).
 */
const DtModal = ({ onClose, onGo, nvrTimestampShort, initial = {} }) => {
  const w = useWhenState({ initial, nvrTimestampShort });
  const handleGo = () => { if (w.valid) onGo(w.value); };

  return (
    <>
      <div className="mcpb-dtp-backdrop" onClick={onClose} data-testid="mcpb-dtp-backdrop" />
      <div className="mcpb-dtp-modal" role="dialog" aria-label="Go to time">
        <div className="mcpb-dtp-header">
          <span className="mcpb-dtp-header__title">Go to time</span>
          <span className="mcpb-dtp-header__clock">
            <span className="mcpb-dtp-header__clock-label">NVR</span>
            {chipTime(nvrTimestampShort)}
          </span>
          <button className="mcpb-dtp-header__close" type="button" onClick={onClose} aria-label="Close">&times;</button>
        </div>

        <div className="mcpb-dtp-body">
          <WhenFields w={w} nvrTimestampShort={nvrTimestampShort} />

          <span className="mcpb-dtp-section-label">Filter by</span>
          <FindEventsChips filters={w.filters} onToggle={w.toggleFilter} />

          <button className="mcpb-dtp-go-btn" type="button" onClick={handleGo} disabled={!w.valid}>Go</button>
        </div>
      </div>
    </>
  );
};

export default DtModal;
